// extracted by mini-css-extract-plugin
export default {"top":"Appreciation_top__7uG4h","box":"Appreciation_box__MYtxA","addButton":"Appreciation_addButton__J2WD3"};